<!-- Icon (conditional) -->
@if (config.hasIcon && config.icon) {
  <div class="hx-snackbar-icon">
    <hx-icon [inline]="true" [svgIcon]="config.icon"></hx-icon>
  </div>
}

<!-- Message text -->
<div class="hx-snackbar-message">{{ config.message }}</div>

<!-- Action and close buttons -->
@if (config.hasAction || config.hasClose) {
  <div class="hx-snackbar-actions">
    <!-- Action button (conditional) -->
    @if (config.hasAction && config.actionLabel) {
      <button class="hx-snackbar-action" type="button" [attr.aria-label]="config.actionLabel" (click)="onAction()">
        {{ config.actionLabel }}
      </button>
    }

    <!-- Close button (conditional) -->
    @if (config.hasClose) {
      <button aria-label="Close notification" class="hx-snackbar-close" type="button" (click)="dismiss()">
        <hx-icon aria-hidden="true" svgIcon="ccs-x-lg" [inline]="true"></hx-icon>
      </button>
    }
  </div>
}
